import styled from 'styled-components';

const WhyChooseUsSectionStyle = styled.section`
	--iconSize: var(--sp9x);
	--distanceTitleContent: var(--sp6x);
	--padBlock: var(--sp7x) var(--sp4x);
	--padBlockT: var(--sp6x);
	--distanceCart: var(--sp5x);
	--distanceIconText: var(--sp4x);
	--itemSize: calc((100% - var(--distanceCart) * 4) / 5);

	.text-section-title {
		margin-bottom: var(--distanceTitleContent);
	}

	.description-text,
	.icon-text-wrapper {
		opacity: 0;
	}

	.wrapper-cart {
		margin-top: calc(var(--distanceTitleContent) * 2);
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: var(--distanceCart);
	}

	.icon-text-wrapper {
		width: var(--itemSize);

		.icon-inner-text-wrapper {
			display: flex;
			flex-direction: column;
			text-align: center;
			align-items: center;
			border: 2px solid var(--textPrimaryColor);
			border-radius: var(--sp3x);
			height: 100%;
			padding: var(--padBlock);
			padding-top: var(--padBlockT);
			gap: var(--distanceIconText);
		}

		svg {
			width: var(--iconSize);
			height: var(--iconSize);
			color: var(--hoverPrimaryColor);
			overflow: visible;
		}
	}

	&.active {
		.description-text {
			opacity: 1;
			transition: var(--trTime) ease-in var(--trTime);
		}

		.icon-text-wrapper {
			opacity: 1;
			transition: var(--trTime) ease-in calc(var(--trTime) * 2 + var(--delayItem) * 0.15s);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceTitleContent: var(--sp4x);

		--iconSize: var(--sp8x);
		--padBlock: var(--sp5x) var(--sp2-5x);
		--padBlockT: var(--sp6x);
		--distanceCart: var(--sp4x);
		--distanceIconText: var(--sp4x);
		--itemSize: calc((100% - var(--distanceCart) * 3) / 4);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceTitleContent: var(--sp3x);

		--iconSize: var(--sp7x);
		--padBlock: var(--sp8x) var(--sp5x);
		--padBlockT: var(--sp6x);
		--distanceCart: var(--sp4x);
		--distanceIconText: var(--sp4x);
		--itemSize: calc((100% - var(--distanceCart) * 2) / 3);
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceTitleContent: var(--sp2-5x);

		--iconSize: var(--sp7x);
		--padBlock: var(--sp5x) var(--sp3x);
		--padBlockT: var(--sp5x);
		--distanceCart: var(--sp3-5x);
		--distanceIconText: var(--sp4x);
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceTitleContent: var(--sp2x);

		--iconSize: var(--sp5x);
		--padBlock: var(--sp4x) var(--sp1x);
		--padBlockT: var(--sp4x);
		--distanceCart: var(--sp2x);
		--distanceIconText: var(--sp2x);

		@media screen and (min-width: 1024px) {
			--itemSize: calc((100% - var(--distanceCart) * 3) / 4);
			--padBlock: var(--sp4x) var(--sp2x);
		}
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--itemSize: 100%;

		--iconSize: var(--sp5x);
		--padBlock: var(--sp3x) var(--sp2x);
		--padBlockT: var(--sp3x);
		--distanceCart: var(--sp2x);
		--distanceIconText: var(--sp2x);
	}
`;
export default WhyChooseUsSectionStyle;
